import { ConfigurationFeatureFlag, ConfigurationModel } from '@tink/config/src/tinkLinkConfig';
import { TransferStatus } from './transfer';

export enum PaymentCheckType {
  INITIATED_BEFORE = 'initiatedBefore',
  FAILED_OR_CANCELLED_BEFORE = 'failedOrCancelledBefore',
}

export type TransferBasicInfo = {
  transferId: string;
  status: TransferStatus;
  providerName: string;
};

export type PaymentPreInitiationCheckPayload = { [T in PaymentCheckType]: boolean | null };

export type PaymentPreInitiationCheckResponse = PaymentPreInitiationCheckPayload & {
  transferBasicInfo?: TransferBasicInfo[];
};

export const rejectDoublePayment = ({ featureFlags }: ConfigurationModel) => {
  return featureFlags.includes(ConfigurationFeatureFlag.REJECT_DOUBLE_PAYMENT);
};

export const rejectFailedOrCancelledPayment = ({ featureFlags }: ConfigurationModel) => {
  return featureFlags.includes(ConfigurationFeatureFlag.REJECT_FAILED_OR_CANCELLED);
};
